export const lockForConsultProfiles = (pRoles: string) => {
    const show =
        pRoles?.includes('collectivity-consult') === true ||
        pRoles?.includes('diagperm-consult') === true
          ? false
          : true;
    return show;
};